import { Module } from '../utils/_application'
import Swiper from '../utils/_swiper'

const $ = jQuery

export default class StepsSlider extends Module {
  ready (app) {
    this.stepsSliders = document.querySelectorAll('.mtt-steps')

    if (this.stepsSliders.length) {
      for (let i = 0; i < this.stepsSliders.length; i++) {
        const sliderWrapper = this.stepsSliders[i]

        new StepSlider(sliderWrapper)
      }
    }
  }
}

class StepSlider {
  constructor (sliderWrapper) {
    this.sliderWrapper = sliderWrapper
    this.addSlider()
  }

  addSlider () {
    this.slider = this.sliderWrapper.querySelector('.swiper-container')

    const nextArrow = this.sliderWrapper.querySelector('.mtt-steps__next')
    const prevArrow = this.sliderWrapper.querySelector('.mtt-steps__prev')

    new Swiper(this.slider, {
      slidesPerView: 1.20,
      spaceBetween: 24,
      watchOverflow: true,
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow
      },
      breakpoints: {
        320: {
          slidesPerView: 1.1
        },
        401: {
          slidesPerView: 1.2
        },
        501: {
          slidesPerView: 1.5
        },
        581: {
          slidesPerView: 2
        },
        761: {
          slidesPerView: 3
        },
        1161: {
          slidesPerView: 4
        },
        1281: {
          slidesPerView: 5
        },
        1400: {
          slidesPerView: 6
        }
      }
    })
  }
}
